export default "<report-component></report-component>\n<br><br>\n<mat-divider></mat-divider>\n<br><br><br>\n<app-documents-misc-list></app-documents-misc-list>"